import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Guid } from 'guid-typescript';

@Injectable({
    providedIn: 'root'
})
export class SelectedBarService {
    private selectedBarIdSubject = new BehaviorSubject<Guid | null>(null);
    public selectedBarId$ = this.selectedBarIdSubject.asObservable();

    private barUpdatedSubject = new Subject<void>();
    public barUpdated$ = this.barUpdatedSubject.asObservable();

    setSelectedBarId(barId: Guid | null): void {
        this.selectedBarIdSubject.next(barId);
    }

    getSelectedBarId(): Guid | null {
        return this.selectedBarIdSubject.value;
    }

    notifyBarUpdated(): void {
        this.barUpdatedSubject.next();
    }
}
